import { authQueryKeys as e } from "../state/useAuthQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { profileApi as r } from "@maat/api-main";
//#region src/queries/workspace/useSwitchProfileMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.switchProfile,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.state() }), i.invalidateQueries({ queryKey: e.me() }), i.removeQueries({ queryKey: ["permission"] }), i.invalidateQueries();
		}
	});
};
//#endregion
export { i as useSwitchProfileMutation };
